import React from 'react';
import * as linkify from 'linkifyjs';
import Highlighter from 'react-highlight-words';

import { MENTION_REGEX, escapeRegex } from 'utils/regex';
import { MentionedUsersFieldFragment } from '__generated__/graphql/legacy/graphql';
import { useRouter } from 'next/router';
import Highlight from '../Highlight/Highlight';
import { IdMap } from './interfaces';

interface HighlightContainerProps {
  content: string;
  mentionedUsers?: MentionedUsersFieldFragment | null;
}

export const HighlightContainer: React.FC<HighlightContainerProps> = ({
  content,
  mentionedUsers,
}) => {
  const router = useRouter();
  const query = router?.query?.q as string;

  let emailAndLinkValues: string[] = [];
  const emailAndLinkMap = {};
  const userIdToAvatarMap: IdMap = {};
  const arrayOfEmailsAndLinks = linkify.find(content);

  emailAndLinkValues = arrayOfEmailsAndLinks
    .filter((node) => {
      let isValid = true;
      try {
        /* eslint-disable no-debugger, no-new */
        new RegExp(node.value);
      } catch (e) {
        isValid = false;
      }
      return isValid;
    })
    .map((node) => {
      emailAndLinkMap[node.value] = node.href;
      return escapeRegex(node.value);
    });

  mentionedUsers?.edges?.forEach((mentionedUser) => {
    const id = mentionedUser?.node?.id;
    if (id) {
      userIdToAvatarMap[id] = mentionedUser?.node?.avatarUrl || '';
    }
  });

  return (
    <Highlighter
      highlightClassName="mentions-highlight"
      highlightTag={(results) => {
        return (
          <Highlight
            className={results.className}
            emailAndLinkMap={emailAndLinkMap}
            highlightMatch={results.children}
            userIdToAvatarMap={userIdToAvatarMap}
          />
        );
      }}
      searchWords={[...emailAndLinkValues, MENTION_REGEX, query]}
      textToHighlight={content}
      caseSensitive
    />
  );
};

export default HighlightContainer;
